/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 26/06/2023
 */
import React, { useState, useEffect } from "react";
import {
  Stack,
  LinearProgress,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material"
import PendingOrgsItem from "./PendingOrgsItem";
import api from "../../../../base/services/ResApi";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import Alerts from "../../../../base/errorHandeling/Alerts";
import SearchIcon from "@mui/icons-material/Search"


const PendingOrgs = ({ updateData, setUpdateData, setPendingCount, refreshKey = 0 }) => {
  const [pendingData, setPendingData] = useState([])
  const [filterData, setfilterData] = useState([])
  const [pendingLoading, setPendingLoading] = useState(true)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  let pendConfig = {
    headers: {
      Action: "V_NON_APPR_ORG",
      "Page-Number": 1,
      "Page-Size": 500,
      "Sort-Column": "org_code",
      "Sort-Order": "asc",
    },
  }

  useEffect(() => {
    setPendingLoading(true)
    api
      .get("/organizations", pendConfig)
      .then((res) => {
        setPendingData(res.data?.dataList)
        setfilterData(res.data?.dataList)
        setPendingCount(res.data?.total)
        setPendingLoading(false)
        setErrorMessages([])
        setIserror(false)
        setIsUnauhtError(false)
        setUpdateData(false)
      })
      .catch((error) => {
        setUpdateData(false)
        setPendingLoading(false)
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
      })
  }, [updateData, isUnauhtError, refreshKey])

  useEffect(() => {
    if (iserror === true) {
      setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
      }, 10000)
    }
  }, [iserror])

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false)
        setSuccessMessages([])
      }, 3000)
    }
  }, [isSuccess])

  const searchFilter = (e) => {
    const searchVal = e.target.value
    const results = pendingData.filter((org) => {
      return org.orgName.toLowerCase().includes(searchVal.toLowerCase())
    })
    setfilterData(results)
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "100%", maxWidth: 360, minHeight: 58, mb: 3 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Organization"
          inputProps={{ "aria-label": "search role" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {pendingLoading ? (
        <LinearProgress />
      ) : (
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          {filterData?.map((d, i) => {
            return (
              <PendingOrgsItem
                key={d?.orgName}
                approveId={d?.approveId}
                orgName={d?.orgName}
                orgCode={d?.orgCode}
                primAddress={d?.primAddress}
                secAddress={d?.secAddress}
                email={d?.email}
                primContact={d?.primContact}
                secContact={d?.secContact}
                description={d?.description}
                action={d?.action}
                setUpdateData={setUpdateData}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
}
export default PendingOrgs;
